var render = function render(_c,_vm){return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48","aria-hidden":"true","fill":"currentColor"}},[_c('path',{attrs:{"d":"M43.143 2.464v3.59H4.857V2.465ZM24 9.643l11.605 11.605-2.572 2.572-7.238-7.238v28.954h-3.589V16.582l-7 7-2.572-2.572Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }